// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuAdminInfo {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.SideMenuAdminInfo_chart {
    flex: 1;
    min-height: 300px;
    margin-top: 20px;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    overflow: hidden;
}

.SideMenuAdminInfo_stats {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 30px;
}

.SideMenuAdminInfo_stat {
    text-align: center;
}

.SideMenuAdminInfo_stat_number {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 5px;
}

.SideMenuAdminInfo_stat_label {
    font-size: 14px;
    color: #666;
}

.SideMenuAdminInfo_graph {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.SideMenuAdminInfo_graph_controls {
    margin-bottom: 15px;
}

.SideMenuAdminInfo_graph_select {
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #ccc;
    margin-right: 10px;
}

.SideMenuAdminInfo_graph_container {
    position: relative;
    min-height: 200px;
}

.SideMenuAdminInfo_controls {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
}

.SideMenuAdminInfo_control_group {
    display: flex;
    gap: 10px;
    justify-content: center;
}

.SideMenuAdminInfo_control {
    padding: 8px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
}

.SideMenuAdminInfo_control.active {
    background: #4CAF50;
    color: white;
    border-color: #4CAF50;
}

.SideMenuAdminInfo_control:hover {
    background: #f5f5f5;
}

.SideMenuAdminInfo_control.active:hover {
    background: #45a049;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/administrator/SideMenuAdminInfo.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".SideMenuAdminInfo {\n    padding: 20px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.SideMenuAdminInfo_chart {\n    flex: 1;\n    min-height: 300px;\n    margin-top: 20px;\n    padding: 20px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    overflow: hidden;\n}\n\n.SideMenuAdminInfo_stats {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-bottom: 30px;\n}\n\n.SideMenuAdminInfo_stat {\n    text-align: center;\n}\n\n.SideMenuAdminInfo_stat_number {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n.SideMenuAdminInfo_stat_label {\n    font-size: 14px;\n    color: #666;\n}\n\n.SideMenuAdminInfo_graph {\n    background: #fff;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.SideMenuAdminInfo_graph_controls {\n    margin-bottom: 15px;\n}\n\n.SideMenuAdminInfo_graph_select {\n    padding: 5px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    margin-right: 10px;\n}\n\n.SideMenuAdminInfo_graph_container {\n    position: relative;\n    min-height: 200px;\n}\n\n.SideMenuAdminInfo_controls {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.SideMenuAdminInfo_control_group {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n}\n\n.SideMenuAdminInfo_control {\n    padding: 8px 16px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.SideMenuAdminInfo_control.active {\n    background: #4CAF50;\n    color: white;\n    border-color: #4CAF50;\n}\n\n.SideMenuAdminInfo_control:hover {\n    background: #f5f5f5;\n}\n\n.SideMenuAdminInfo_control.active:hover {\n    background: #45a049;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
